<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #ccc; /* old IE */
  background-color: #ccc; /* Modern Browsers */
}
.my-grid {
  overflow: auto;
  min-height: 50px;
  width: 100%; 
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h4>Bottom-Hole Assembly</h4>
      <div>
        <DxButton
          icon="download"
          hint="Download BHA excel file"
          :height="40"
          />
        <DxButton
          id="refreshButton"
          icon="revert"
          hint="Refresh"
          :height="40"
          @click="refreshGrids" />
      </div>
    </div>
            <br />
            <h5 align="left"> 
                  BHA Profile
            </h5>
            <DxDataGrid
              id="report-grid"
              ref="bhaDataGrid"
              :data-source="bhaDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :height="300"
              :remote-operations="true"
              date-serialization-format="yyyy-MM-dd"
              @saved="saveRows"
              @selection-changed="onSelectionChanged"
              @row-inserting="onRowInserting"
              @row-updating="onRowUpdating"
              @row-removed="onRowRemoved"
              @editor-preparing="onEditorPreparing"
              @editing-start="onEditingStart"
              @init-new-row="onInitNewRow"
            >
              <DxPaging :enabled="true" :page-size="5" />
              <DxSelection mode="single"/>
              <DxEditing
                :allow-updating="editable"
                :allow-adding="editable"
                :allow-deleting="editable"
                :use-icons="true"
                mode="row"/>
              <DxColumn
                type="buttons"
                width="5%"
              >
                <GridButton name="edit"/>
                <GridButton name="delete"/>
              </DxColumn>
                <DxColumn caption="No." :calculate-cell-value="setReportNo"  width="70" >
                  <DxFormItem :visible="false"/>
                </DxColumn>
                <DxColumn data-field="runNo" data-type="number" caption="Run No">
                  <DxFormItem :visible="true" />
                </DxColumn>
                <DxColumn data-field="dateIn" data-type="date" caption="Date In">
                  <DxFormItem :visible="true" />
                </DxColumn>
                <DxColumn data-field="dateOut" data-type="date" caption="Date Out">
                  <DxFormItem :visible="true" />
                </DxColumn>
                <DxColumn data-field="sumLength" data-type="number" caption="Total BHA Length">
                  <DxFormItem :visible="false" />
                </DxColumn>
                <DxColumn data-field="bitId" data-type="number" caption="Bit No" > <!-- :calculate-display-value="setBitNoDisplay" -->
                  <DxLookup
                    :data-source="optionBitNo"
                    value-expr="value"
                    display-expr="text"/>
                </DxColumn>
                <DxColumn data-field="bhaType" data-type="number" caption="BHA Type">
                  <DxLookup
                    :data-source="optionBHATypes"
                    value-expr="value"
                    display-expr="text"
                  /> 
                </DxColumn>
                <DxColumn data-type="string" caption="BHA Purpose" :calculate-display-value="bhaPurpose">
                  <DxFormItem :visible="false" />
                </DxColumn>
                <DxColumn data-field="remarks" data-type="string" caption="Remarks"/>
                
            </DxDataGrid>
            <br />
            <h5 align="left"> 
              BHA Component
            </h5>
            <br />
            <DxDataGrid
              id="component-grid"
              ref="componentGrid"
              :data-source="bhaComponentDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              :remote-operations="false"
              @saved="saveComponents"
            >
              <DxPaging :enabled="true" :page-size="5" />
              <DxScrolling column-rendering-mode="virtual"/>
              <DxSelection mode="single"/>
              <DxEditing
                :allow-updating="componentEditable"
                :allow-adding="componentEditable"
                :allow-deleting="componentEditable"
                :use-icons="true"
                mode="form"/>
              
              <DxColumn
                type="buttons"
                width="70"
              >
                <GridButton name="edit"/>
                <GridButton name="delete"/>
              </DxColumn>
              <DxColumn caption="No." cell-template="rowNoTemplate" width="50" :read-only="true">
                <DxFormItem :visible="false"/>
              </DxColumn>
              <template #rowNoTemplate="{ data }">
                  {{ data.rowIndex + 1 }}
                </template>
              <!-- DxColumn :visible="true" data-field="bhaId" data-type="number" caption="Run No">
                <DxLookup
                    :data-source="optionRunNo"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn -->
              <DxColumn :width="200" :visible="true" data-field="sectionType" data-type="string" caption="Section Type" :calculate-display-value="setSectionTypeDisplay">
                <DxLookup
                    :data-source="optionsComboSectionType"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :visible="true" data-field="componentType" data-type="string" caption="Component Type" />
              <DxColumn :visible="true" data-field="description" data-type="string" caption="Item Description" />
              <DxColumn :visible="true" data-field="company" data-type="string" caption="Owner Company" />
              <DxColumn :visible="true" data-field="noOfJoints" data-type="number" caption="Number of Joints" />
              <DxColumn :visible="true" data-field="totalLength" data-type="number" caption="Total Component Length" />
              <DxColumn :visible="true" data-field="innerDiameter" data-type="string" caption="Inner Diameter" />
              <DxColumn :visible="true" data-field="outerDiameter" data-type="string" caption="Outer Diameter" />
              <DxColumn :visible="true" data-field="gaugeDiameter" data-type="string" caption="Gauge Diameter" />
              <DxColumn :visible="true" data-field="pounder" data-type="number" caption="Pounder" />
              <DxColumn caption="Cum. Weight" :calculate-cell-value="setCumWeight"/>
              <DxColumn :visible="true" data-field="connection" data-type="string" caption="Connection" />
            </DxDataGrid>
        </div>
</template>

<script>
import { formMethods, formComputed, authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling,
  DxButtton as GridButton
} from 'devextreme-vue/data-grid'
import 'devextreme-vue/text-area'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'
import {maxBy} from 'lodash'

const isNotEmpty = (value) => value !== undefined && value !== null && value !== ''

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    DxFormItem,
    DxLookup,
    DxButton,
    GridButton
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    reportMap: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      form: {},
      show: true,
      stillLoading: false,
      progressLoading: 0,
      optionsComboHoleSize: [],
      optionBHATypes: [
        { value: 0, text: "Steerable BHA" }, { value: 1, text: "Rotary BHA" }, { value: 2, text: "Slick BHA" }
      ],
      optionsComboSectionType: [],
      hasData: false,
      editableOps: this.editable,
      files: [],
      sourceSubmitId: 0,
      showOptionContigency: false,
      fileNameUpload: '',
      fileUpload: '',
      loadingOn: false,
      bhaData: [],
      bitData: [],
      bhaDataSource: null,
      bhaComponentDataSource: [],
      optionBitNo: [],
      optionRunNo: [],
      maxRunNo: 0,
      bhaDataSelected: undefined,
      tableFields: [],
      reportIsLoading: false,
      componentEditable: false,
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    reportNo() {
      const match = this.reportMap.find(x => x.submitId === this.submitId)
      return match === undefined ? 0 : match.index
    }
  },
  watch: {
    submitId: function (value) {
      this.bhaDataSelected = undefined
      this.refreshGrids()
    },
    editable: function (val) {
      this.editableOps = val
    },
  },
  created: function () {
    this.loadBitData()
    this.loadCombo()
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.bhaDataSource = new CustomStore({
        key: 'id',
        load: (loadOptions) => {
            let params = {}
            params.wellId = this.wellId
            let options = [ 'filter', 'group', 'groupSummary', 'parentIds', 'requireGroupCount', 'requireTotalCount', 'searchExpr', 'searchOperation',
              'searchValue', 'select', 'sort', 'skip', 'take', 'totalSummary', 'userData'
            ]
            options.forEach(function(i) {
              if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                params[i] = loadOptions[i]
              }
            });
          const url = mapApiUrl('/api/form/master/bha/list-paged/well')
          return axios.get(url, {params: params})
               .then((response) => {
                 const result = []
                 for (const entry of response.data.data) {
                   let item = {...entry}
                   const match = this.reportMap.findIndex(x => x.submitId === item.submitId)
                   if (match >= 0) {
                     item.reportNo = match 
                   }
                   result.push(item)
                 }
                 this.maxRunNo = result.length
                 return {data: result, totalCount: response.data.totalCount}
                 })
                .catch(error => new Error(error.message)) 
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result)
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
                this.optionRunNo = []
                for (const bha of result) {
                  this.optionRunNo.push({value: bha.id, text: bha.runNo})
                }
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          delete values.sumLength
          delete values.bitOperation

          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/bha/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/bha/add')
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/bha/delete')
          return fetch(url + `?id=${key}&submitId=${this.submitId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
      this.bhaComponentDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const url = mapApiUrl('/api/form/master/bha/component/list')
          if (this.bhaDataSelected === undefined) return []
          return fetch(url + `?bhaId=${this.bhaDataSelected.id}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') })
        },
        onLoaded: function(result) {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0]);
            }
        },
        insert: (values) => {
          values.bhaId = this.bhaDataSelected.id
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/bha/component/add')
          return axios.post(url, qs.stringify(values)).then(response => {
            this.maxRunNo++
            return response.data })
        },
        update: (key, values) => {
          values.bhaId = this.bhaDataSelected.id
          values.id = key
          const url = mapApiUrl('/api/form/master/bha/component/add')
          return axios.post(url, qs.stringify(values)).then(response => response.data)
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/master/bha/component/delete')
          return fetch(url + `?id=${key}&bhaId=${this.bhaDataSelected.id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
    },
    setReportNo(rowData) {
      const match = this.reportMap.find(x => x.submitId === rowData.submitId)
      return match !== undefined ? match.index : ""
    },
    refreshGrids() {
      this.$refs.bhaDataGrid.instance.refresh()
    },
    calculateBHALength(rowData) {
      return 0
    },
    bhaPurpose(rowData) {
      let bit = this.bitData.find(x => x.id === rowData.bitId)
      if (bit !== undefined) {
        return bit.operation
      }
      return null 
    },
    setCumWeight(rowData) {
      return rowData.totalLength * rowData.pounder / 1000 * 3.281 // asumsi imperial system
    },
    setSectionTypeDisplay(rowData) {
      return rowData.sectionType
    },
    setBitNoDisplay(rowData) {
      let bitNo = this.optionBitNo.find(x => x.value === rowData.bitId)
      if (bitNo !== undefined) {
        return bitNo.text
      }
      return ""
    },
    loadCombo() {
      this.getComboListWorkstringSectionType({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboSectionType = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboSectionType.push(_temp)
        }
      })
    },
    loadData() {
      this.bhaData = []
      const url = mapApiUrl('/api/form/master/bha/list-view')
      let params={submitId: this.submitId}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params,crossdomain:true
      })
      .then((response) => {
        this.reportIsLoading = false
        this.bhaData = response.data
        this.reIndexRun()
        this.populateOptionRunNo()
      })
    },
    loadBhaComponent() {
      if (this.bhaDataSelected === undefined) return

      this.bhaComponentData = []
      const url = mapApiUrl('/api/form/master/bha/component/list')
      let params={bhaId: this.bhaDataSelected.id}
      this.reportIsLoading = true
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        this.reportIsLoading = false
        this.bhaComponentData = response.data === undefined ? [] : response.data
      })
    },
    loadBitData() {

      const url = mapApiUrl('/api/form/master/bit/list/well')
      let params={wellId: this.wellId}
      axios
      .get(url, {
        params: params,crossdomain:true
      })
      .then((response) => {
        this.bitData = response.data
        this.optionBitNo = []
        for (const bit of response.data) {
          this.optionBitNo.push({ text: `${bit.no} - ${bit.manufacturer} ${bit.model } ${bit.size}` , value: bit.id })
        }
      })
    },
    addRow(tableData) {
      if (tableData.length > 0)
      tableData.push(tableData[tableData.length-1])
    },
    removeRow(rowIndex) {
      if (this.dummyData.length > rowIndex) {
        this.dummyData[rowIndex] = this.dummyData[rowIndex-1]
        this.dummyData.pop()
        rowIndex = -1
      }
    },
    reIndexRun() {
      let index = 1
      let cumLength = 0
      this.bhaData.forEach(element => {
        cumLength += element.totalComponentLength
        // element.bhaLength = cumLength
        const bit = this.bitData.find(x => x.id === element.bitId)
        if (bit !== undefined) {
          element.bitNo = bit.no
          element.dateIn = bit.dateIn
          element.bhaPurpose = bit.operation
        }
      })
    },
    onInitNewRow(e) {
      e.data.submitId = this.submitId
      const maxRunNo = maxBy(e.component.getDataSource().items(), 'runNo')
      e.data.runNo = maxRunNo.runNo + 1
    },
    onEditingStart(e) {
      this.componentEditable = this.editable && this.submitId === e.data.submitId
      e.cancel = !this.componentEditable
      if (e.cancel) {
        notify({ message: 'You can not change/remove other report.', width: 300 }, 'warning', 3000)
      }
    },
    onEditorPreparing(e) {
      e.component.clearSelection()
    },
    onRowRemoved(e) {
      notify({ message: 'BHA data has been removed.', width: 500 }, 'success', 3000)
    },
    onRowInserting(e) {
      let duration = Date.parse(e.data.dateOut) - Date.parse(e.data.dateIn)
      e.cancel = duration <= 0 ?  Promise.reject(new Error('Date in must predate Date out')) : false
    },
    onRowUpdating(e) {
      let duration = 1
      if (e.newData.dateIn !== undefined) {
        duration = e.oldData.dateOut - Date.parse(e.newData.dateIn)
      }
      if (e.newData.dateOut !== undefined) {
        duration = Date.parse(e.newData.dateOut) - e.oldData.dateIn
      }
      e.cancel = duration <= 0 ?  Promise.reject(new Error('Date in must predate Date out')) : false
    },
    onSelectionChanged(event) {
      this.bhaDataSelected = event.selectedRowsData[0]
      // this.bhaComponentDataSource.load()
      this.$refs.componentGrid.instance.refresh()
    },
    onBitSelectionChanged(event) {
    },
    saveRows(e) {
      notify({ message: 'BHA data has been recorded.', width: 500 }, 'success', 3000)
    },
    saveComponents(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      rowData.bhaId = this.bhaDataSelected.id

      if (isNaN(rowData.id)) {
        delete rowData.id
      }
      
      const url = mapApiUrl('/api/form/master/bha/component/add')
      axios.post(url, qs.stringify(rowData)).then((response) => {
          notify({ message: 'BHA component was recorded.', width: 500 }, 'success', 3000)
        })
      const selectedBit = this.bitData.find(x => x.no === rowData.runNo)
      if (selectedBit !== undefined) {
        rowData.dateIn = selectedBit.dateIn
        rowData.dateOut = selectedBit.dateOut
        rowData.totalBhaLength = selectedBit.totalBhaLength
        rowData.bitNo = selectedBit.no
        rowData.bhaType = selectedBit.bhaType
        rowData.bhaPurpose = selectedBit.operation
      }
    }, 
  },
 }
</script>